"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateQRNumber = validateQRNumber;
function calculateModulo10Recursive(number) {
  const carry = [0, 9, 4, 6, 8, 2, 7, 1, 3, 5];
  let sum = 0;

  // Process each digit from left to right
  for (let i = 0; i < number.length; i++) {
    const digit = parseInt(number.charAt(i));
    sum = carry[(sum + digit) % 10];
  }
  return (10 - sum) % 10;
}
function validateQRNumber(reference) {
  // Remove any spaces
  reference = reference.replace(/\s/g, '');
  if (reference.length !== 27 || !/^\d+$/.test(reference)) {
    return false;
  }
  const number = reference.slice(0, 26);
  const checkDigit = parseInt(reference.charAt(26));

  // Calculate the check digit using modulo 10 recursive
  const calculatedCheckDigit = calculateModulo10Recursive(number);
  return checkDigit === calculatedCheckDigit;
}